/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetListAllAccountsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetListAllAccountsQuery = {
  __typename?: 'Query',
  listAllAccounts?: Array<{
    __typename?: 'AccountDetails',
    id: number,
    accountType?: Types.AccountType | null,
    username?: string | null,
    displayName?: string | null,
    email?: string | null,
    relation?: {
      __typename?: 'Relation',
      id: number,
      name: string
    } | null
  }> | null
};

export type GetAccountByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['Long']['input'];
}>;


export type GetAccountByIdQuery = {
  __typename?: 'Query',
  getAccountById: {
    __typename?: 'AccountDetails',
    id: number,
    email?: string | null,
    secondEmail?: string | null,
    userEmailNotificationType?: Types.EmailNotificationType | null,
    userPreferences?: unknown | null,
    displayName?: string | null,
    username?: string | null,
    accountType?: Types.AccountType | null,
    phone?: string | null,
    mobilePhone?: string | null,
    allowSystemInput: boolean,
    allowSystemVoyageInput?: boolean | null,
    allowSystemPlanningInput?: boolean | null,
    batchMessages?: boolean | null,
    validated: boolean,
    language?: {
      __typename?: 'Language',
      id: number,
      code: string,
      description: string
    } | null,
    preferredCurrency?: {
      __typename?: 'Currency',
      isoCode?: string | null,
      rate?: number | null,
      symbol?: string | null
    } | null,
    fleets?: Array<{
      __typename?: 'Fleet',
      id: number,
      description: string,
      activeFleet: boolean,
      ships?: Array<{
        __typename?: 'Ship',
        id: number,
        name: string,
        eni?: string | null,
        mmsi?: number | null,
        owner?: {
          __typename?: 'Relation',
          id: number,
          name: string
        } | null,
        skipper?: {
          __typename?: 'Relation',
          id: number,
          name: string
        } | null,
        operator?: {
          __typename?: 'Relation',
          id: number,
          name: string
        } | null
      }> | null
    }> | null,
    relation?: {
      __typename?: 'Relation',
      id: number,
      name: string
    } | null,
    ship?: {
      __typename?: 'Ship',
      id: number,
      name: string,
      eni?: string | null,
      mmsi?: number | null,
      owner?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      skipper?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      operator?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null
    } | null,
    jsonPushSettings?: {
      __typename?: 'JsonPushSettings',
      jsonUrl?: string | null,
      jsonUsername?: string | null,
      jsonPassword?: string | null,
      customHeaderKey?: string | null,
      customHeaderValue?: string | null
    } | null
  }
};

export type GetUserDetailsQueryVariables = Types.Exact<{
  userUuid: Types.Scalars['Uuid']['input'];
}>;


export type GetUserDetailsQuery = {
  __typename?: 'Query',
  getAccountByUuid: {
    __typename?: 'AccountDetails',
    userPreferences?: unknown | null,
    id: number,
    email?: string | null,
    secondEmail?: string | null,
    userEmailNotificationType?: Types.EmailNotificationType | null,
    displayName?: string | null,
    username?: string | null,
    accountType?: Types.AccountType | null,
    phone?: string | null,
    mobilePhone?: string | null,
    allowSystemInput: boolean,
    allowSystemVoyageInput?: boolean | null,
    allowSystemPlanningInput?: boolean | null,
    batchMessages?: boolean | null,
    validated: boolean,
    favorites: Array<{
      __typename?: 'Favorite',
      label?: string | null,
      entityId: number,
      entityType: Types.FavoriteType,
      relation?: {
        __typename?: 'Relation',
        id: number,
        name: string,
        email?: string | null,
        applicationRelation?: boolean | null,
        customer?: boolean | null,
        operator?: boolean | null,
        shipManger?: boolean | null,
        isShipManager?: boolean | null,
        supplier?: boolean | null,
        address?: {
          __typename?: 'Address',
          street?: string | null,
          zipCode?: string | null,
          town?: string | null,
          country?: string | null
        } | null,
        contacts: Array<{
          __typename?: 'Contact',
          id: number,
          type?: string | null,
          name?: string | null,
          insertion?: string | null,
          surName?: string | null,
          email?: string | null
        }>
      } | null,
      location?: {
        __typename?: 'Location',
        id: number,
        description: string,
        code?: string | null,
        type: Types.LocationType,
        abbreviation?: string | null,
        address?: {
          __typename?: 'Address',
          zipCode?: string | null,
          town?: string | null
        } | null,
        locationGroups: Array<{
          __typename?: 'Location',
          id: number,
          description: string,
          type: Types.LocationType
        }>
      } | null
    }>,
    language?: {
      __typename?: 'Language',
      id: number,
      code: string,
      description: string
    } | null,
    preferredCurrency?: {
      __typename?: 'Currency',
      isoCode?: string | null,
      rate?: number | null,
      symbol?: string | null
    } | null,
    fleets?: Array<{
      __typename?: 'Fleet',
      id: number,
      description: string,
      activeFleet: boolean,
      ships?: Array<{
        __typename?: 'Ship',
        id: number,
        name: string,
        eni?: string | null,
        mmsi?: number | null,
        owner?: {
          __typename?: 'Relation',
          id: number,
          name: string
        } | null,
        skipper?: {
          __typename?: 'Relation',
          id: number,
          name: string
        } | null,
        operator?: {
          __typename?: 'Relation',
          id: number,
          name: string
        } | null
      }> | null
    }> | null,
    relation?: {
      __typename?: 'Relation',
      id: number,
      name: string
    } | null,
    ship?: {
      __typename?: 'Ship',
      id: number,
      name: string,
      eni?: string | null,
      mmsi?: number | null,
      owner?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      skipper?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      operator?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null
    } | null,
    jsonPushSettings?: {
      __typename?: 'JsonPushSettings',
      jsonUrl?: string | null,
      jsonUsername?: string | null,
      jsonPassword?: string | null,
      customHeaderKey?: string | null,
      customHeaderValue?: string | null
    } | null
  }
};


export const GetListAllAccountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListAllAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listAllAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accountType"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"relation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetListAllAccountsQuery, GetListAllAccountsQueryVariables>;
export const GetAccountByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAccountById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAccountById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"secondEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userEmailNotificationType"}},{"kind":"Field","name":{"kind":"Name","value":"userPreferences"}},{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"preferredCurrency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isoCode"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fleets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"activeFleet"}},{"kind":"Field","name":{"kind":"Name","value":"ships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"eni"}},{"kind":"Field","name":{"kind":"Name","value":"mmsi"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"skipper"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"operator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"accountType"}},{"kind":"Field","name":{"kind":"Name","value":"relation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"eni"}},{"kind":"Field","name":{"kind":"Name","value":"mmsi"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"skipper"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"operator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jsonPushSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jsonUrl"}},{"kind":"Field","name":{"kind":"Name","value":"jsonUsername"}},{"kind":"Field","name":{"kind":"Name","value":"jsonPassword"}},{"kind":"Field","name":{"kind":"Name","value":"customHeaderKey"}},{"kind":"Field","name":{"kind":"Name","value":"customHeaderValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePhone"}},{"kind":"Field","name":{"kind":"Name","value":"allowSystemInput"}},{"kind":"Field","name":{"kind":"Name","value":"allowSystemVoyageInput"}},{"kind":"Field","name":{"kind":"Name","value":"allowSystemPlanningInput"}},{"kind":"Field","name":{"kind":"Name","value":"batchMessages"}},{"kind":"Field","name":{"kind":"Name","value":"validated"}}]}}]} as unknown as DocumentNode<GetAccountByIdQuery, GetAccountByIdQueryVariables>;
export const GetUserDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userUuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAccountByUuid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userUuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}},{"kind":"Field","name":{"kind":"Name","value":"favorites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GeneralFavorite"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userPreferences"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"secondEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userEmailNotificationType"}},{"kind":"Field","name":{"kind":"Name","value":"userPreferences"}},{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"preferredCurrency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isoCode"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fleets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"activeFleet"}},{"kind":"Field","name":{"kind":"Name","value":"ships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"eni"}},{"kind":"Field","name":{"kind":"Name","value":"mmsi"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"skipper"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"operator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"accountType"}},{"kind":"Field","name":{"kind":"Name","value":"relation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"eni"}},{"kind":"Field","name":{"kind":"Name","value":"mmsi"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"skipper"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"operator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jsonPushSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jsonUrl"}},{"kind":"Field","name":{"kind":"Name","value":"jsonUsername"}},{"kind":"Field","name":{"kind":"Name","value":"jsonPassword"}},{"kind":"Field","name":{"kind":"Name","value":"customHeaderKey"}},{"kind":"Field","name":{"kind":"Name","value":"customHeaderValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePhone"}},{"kind":"Field","name":{"kind":"Name","value":"allowSystemInput"}},{"kind":"Field","name":{"kind":"Name","value":"allowSystemVoyageInput"}},{"kind":"Field","name":{"kind":"Name","value":"allowSystemPlanningInput"}},{"kind":"Field","name":{"kind":"Name","value":"batchMessages"}},{"kind":"Field","name":{"kind":"Name","value":"validated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GeneralFavorite"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Favorite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"relation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"applicationRelation"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"operator"}},{"kind":"Field","name":{"kind":"Name","value":"shipManger"}},{"kind":"Field","name":{"kind":"Name","value":"isShipManager"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"town"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"insertion"}},{"kind":"Field","name":{"kind":"Name","value":"surName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"town"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserDetailsQuery, GetUserDetailsQueryVariables>;